module.exports = __webpack_public_path__ + "res/ic_open_out_black.ae184d4aed7fb2d921b872712e30b45c.png";